import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addFromColumn,
    convertStartEndDatesForFile,
    sortCurrency,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from "../shared/tableFunctions";
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import FuseTheme from "../global/theme";
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import ReturnsTableIcon from 'material-ui/svg-icons/navigation/arrow-back';
import SalesTableIcon from 'material-ui/svg-icons/navigation/arrow-forward';

const styles = {
    headerButton: {
        display: 'inline-block',
        width: 30,
        minWidth: 36,
        height: 30,
        lineHeight: '30px',
        color: FuseTheme.palette.alternateTextColor,
        margin: 0,
    },
    headerButtonIcon: {
        display: 'inline-block',
        position: 'absolute',
        top: 4,
        right: 0,
        color: FuseTheme.palette.alternateTextColor,
        margin: '0 6px 0 8px',
        verticalAlign: 'middle',
        pointerEvents: 'none',
    },
    headerButtonLink: {
        display: 'inline-block',
        color: 'transparent',
        margin: 0,
        overflow: 'hidden',
    },
};

/**
 * Class for displaying Sales Summary Product Units Returned and Sold in two tables
 *
 */
class SalesSummaryReportProductTables extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnsSummaryList: [],
            returnsSummaryTableData: [],
            returnsSummaryTableHeaders: [
                {label: 'Product Name', key: 'product_name'},
                {label: 'Unit Type', key: 'product_unit_type'},
                {label: 'Total $ Amount', key: 'total_returned'},
            ],
            message: null,
            salesSummaryList: [],
            salesSummaryTableData: [],
            salesSummaryTableHeaders: [
                {label: 'Product Name', key: 'product_name'},
                {label: 'Unit Type', key: 'product_unit_type'},
                {label: 'Total $ Amount', key: 'total_sold'},
            ],
            summariesComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listDataReturns, this.props.listDataSales);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.listDataReturns !== this.props.listDataReturns ||
            nextProps.listDataSales !== this.props.listDataSales
        ) {
            this.setState({
                returnsSummaryList: [],
                returnsSummaryTableData: [],
                salesSummaryList: [],
                salesSummaryTableData: [],
                summariesComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.listDataReturns !== this.props.listDataReturns ||
            prevProps.listDataSales !== this.props.listDataSales
        ) {
            this.processData(this.props.listDataReturns, this.props.listDataSales);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Arrange data for use by table
     *
     * @param dataReturns
     * @param dataSales
     */
    processData(dataReturns, dataSales) {

        const emptyCurrency = toCurrency(0);
        let returnsSummaryList = [];
        let salesSummaryList = [];

        if (dataReturns) {
            let returnsLength = dataReturns.length;
            for (let r = 0; r < returnsLength; r++) {
                let rResult = dataReturns[r];
                let rProductUnit = rResult.product_unit_info.hits.hits[0]._source;
                let qtyReturned = (rResult.qty_returned) ? rResult.qty_returned.value : 0;
                let subtotalReturned = (rResult.agg_subtotal_returned) ? rResult.agg_subtotal_returned.value : emptyCurrency;

                const rRow = this.populateProductRow(rProductUnit);
                rRow.qty_returned = (qtyReturned) ? qtyReturned : 0;
                rRow.total_returned = (subtotalReturned) ? (toCurrency(subtotalReturned / 100)) : emptyCurrency;
                returnsSummaryList.push(rRow);
            }
        }

        if (dataSales) {
            let salesLength = dataSales.length;
            for (let s = 0; s < salesLength; s++) {
                let sResult = dataSales[s];
                let sProductUnit = sResult.product_unit_info.hits.hits[0]._source;
                let qtySold = (sResult.qty_sold) ? sResult.qty_sold.value : 0;
                let subtotalSold = (sResult.agg_subtotal) ? sResult.agg_subtotal.value : emptyCurrency;

                const sRow = this.populateProductRow(sProductUnit);
                sRow.qty_sold = (qtySold) ? qtySold : 0;
                sRow.total_sold = (subtotalSold) ? (toCurrency(subtotalSold / 100)) : emptyCurrency;
                salesSummaryList.push(sRow);
            }
        }

        // Finalize table data
        this.setState({
            returnsSummaryList: returnsSummaryList,
            returnsSummaryTableData: returnsSummaryList,
            salesSummaryList: salesSummaryList,
            salesSummaryTableData: salesSummaryList,
            summariesComplete: true,
        });
        this.props.onSummariesComplete('product', true);
    }

    /**
     * Populate row with Product Unit data
     *
     * @param item
     * @return Object
     */
    populateProductRow(item) {
        return {
            product_category_name: (item.product_category_name) ? item.product_category_name : '(None)',
            product_name: (item.product_name) ? item.product_name : '(None)',
            product_unit_id: (item.product_unit_id) ? item.product_unit_id : '(None)',
            product_unit_type: (item.product_unit_type) ? item.product_unit_type : '(None)'
        };
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param tableName
     * @param table
     */
    handleSortOrFilterChange(event, tableName, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            if (tableName === 'returns') {
                this.setState({
                    returnsSummaryTableData: tableData
                });
            } else if (tableName === 'sales') {
                this.setState({
                    salesSummaryTableData: tableData
                });
            }
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            dataIsFiltered,
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            returnsSummaryList,
            returnsSummaryTableData,
            returnsSummaryTableHeaders,
            salesSummaryList,
            salesSummaryTableData,
            salesSummaryTableHeaders,
            summariesComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const isFilteredString = (dataIsFiltered) ? '-filtered' : '';
        const defaultReturnsSort = setDefaultTableSort({field: 'total_returns', order: 'DESC'});
        const defaultSalesSort = setDefaultTableSort({field: 'total_sold', order: 'DESC'});

        // ReactTable headers and columns for both Tables
        const returnsTableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Product Name',
                        accessor: 'product_name',
                    },
                    {
                        Header: 'Unit Type',
                        accessor: 'product_unit_type',
                        style: tableStyles.tdMax
                    },
                    {
                        Header: () => (<span>Total $<br/>Amount</span>),
                        accessor: 'total_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(returnsSummaryTableData, 'total_returned'))}
                            </span>
                        )
                    },
                ]
            }
        ];

        const salesTableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Product Name',
                        accessor: 'product_name',
                    },
                    {
                        Header: 'Unit Type',
                        accessor: 'product_unit_type',
                        style: tableStyles.tdMax
                    },
                    {
                        Header: () => (<span>Total $<br/>Amount</span>),
                        accessor: 'total_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(salesSummaryTableData, 'total_sold'))}
                            </span>
                        )
                    },
                ]
            }
        ];

        return (
            <div>
                {summariesComplete &&
                <div>
                    <div className="reports-table-container half">

                        {/* Table Header: Sales Summary Products Sold */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container table-header-button-container">
                                {/* Export Sales Summary Products Sold */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={styles.headerButton}
                                >
                                    <ExportIcon style={styles.headerButtonIcon}/>
                                    <CSVLink
                                        data={salesSummaryTableData}
                                        headers={salesSummaryTableHeaders}
                                        filename={'Sales-Summary-Products-Purchased-' + system + '-' + dateString + isFilteredString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={styles.headerButtonLink}
                                    >
                                        Export
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <SalesTableIcon style={commonStyles.summaryIconSmall}/>
                                <span>Top 10 Product Units Purchased</span>
                            </h3>
                        </div>

                        {/* Table: Sales Summary Products Sold */}
                        <ReactTable
                            key="table-sales-summary-products-sold"
                            data={salesSummaryList}
                            columns={salesTableColumns}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10]}
                            showPagination={true}
                            defaultSorted={defaultSalesSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, 'sales', this.summaryProductsSoldReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, 'sales', this.summaryProductsSoldReactTable)}
                            ref={(r) => this.summaryProductsSoldReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped overflow no-print"
                        />
                        <ReactTable
                            key="table-sales-summary-products-sold-print"
                            data={salesSummaryTableData}
                            columns={salesTableColumns}
                            defaultPageSize={20}
                            showPagination={false}
                            defaultSorted={defaultSalesSort}
                            filterable
                            resizable={false}
                            minRows={1}
                            className="print-only"
                        />
                    </div>

                    <div className="reports-table-container half">

                        {/* Table Header: Sales Summary Products Returned */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container table-header-button-container">
                                {/* Export Sales Summary Products Returned */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={styles.headerButton}
                                >
                                    <ExportIcon style={styles.headerButtonIcon}/>
                                    <CSVLink
                                        data={returnsSummaryTableData}
                                        headers={returnsSummaryTableHeaders}
                                        filename={'Sales-Summary-Products-Returned-' + system + '-' + dateString + isFilteredString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={styles.headerButtonLink}
                                    >
                                        Export
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <ReturnsTableIcon style={commonStyles.summaryIconSmall}/>
                                <span>Top 10 Product Units Returned</span>
                            </h3>
                        </div>

                        {/* Table: Sales Summary Products Returned */}
                        <ReactTable
                            key="table-sales-summary-products-returned"
                            data={returnsSummaryList}
                            columns={returnsTableColumns}
                            defaultPageSize={5}
                            showPagination={true}
                            pageSizeOptions={[5, 10]}
                            defaultSorted={defaultReturnsSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, 'returns', this.summaryProductsReturnedReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, 'returns', this.summaryProductsReturnedReactTable)}
                            ref={(r) => this.summaryProductsReturnedReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped overflow no-print"
                        />
                        <ReactTable
                            key="table-sales-summary-products-returned-print"
                            data={returnsSummaryTableData}
                            columns={returnsTableColumns}
                            defaultPageSize={20}
                            showPagination={false}
                            defaultSorted={defaultReturnsSort}
                            filterable
                            resizable={false}
                            minRows={1}
                            className="print-only"
                        />
                    </div>
                </div>
                }
            </div>
        )
    }
}

SalesSummaryReportProductTables.propTypes = {
    addField: PropTypes.bool,
    dataIsFiltered: PropTypes.bool,
    endDate: PropTypes.string,
    listDataReturns: PropTypes.array,
    listDataSales: PropTypes.array,
    onDisplayMessage: PropTypes.func,
    onSummariesComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

SalesSummaryReportProductTables.defaultProps = {
    addField: true,
    dataIsFiltered: false,
    endDate: null,
    startDate: null,
};

export default SalesSummaryReportProductTables;



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesSummaryReportProductTables.js